import React, { useState, useEffect, useMemo } from "react";
import Moment from "moment";
import { get, map, uniqBy } from "lodash";
import PropTypes from "prop-types";
// redux
// import { tagChat } from "@Actions/chats";
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
// import IKModal from "@Components/IkModal";
import Screen from "@Components/Screen";
import FirstResponse from "./Components/FirstResponseTable";
import SummaryUserTable from "./Components/SummaryUserTable";
import UsersGroupsTable from "./Components/UsersGroupsTable";
import SummaryGroupsTable from "./Components/SummaryGroupsTable";
import DetailedTable from "./Components/DetailedTable";

// Utils
import dataHandler from "@Utils/dataHandler";
// import { getStateQuantity } from "../Monitor/Utils";
import ActionUserCrud from "./Modals/ActionUserCrud";

// Styles
import styles from "./styles.module.css";

const TableActionUser = ({ dispatch, chatCurrent, userName, companyName, channels }) => {
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [platformfilters, setPlatformfilters] = useState([]);
	const [groupsfilters, setGroupsfilters] = useState([]);
	const [tagsSelected, setTagsSelected] = useState([]);
	const [startDate, setStartDate] = useState(Moment().format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState("");
	const [contacts, setContacts] = useState("");
	const [agents, setAgents] = useState([]);
	const [note, setNote] = useState("");
	const [checkAlllData, setCheckAllData] = useState([]);
	const [dateField, setDateField] = useState("closeDate");
	const [showTable, setShowTable] = useState(false);
	const [channelFilters, setChannelFilters] = useState([]);
	const [isOpenModal, setIsOpenModal] = useState(true);
	const [tableValue, setTableValue] = useState({});
	const [seletedFilteres, setSeletedFilteres] = useState("");
	const [appliedFilters, setAppliedFilters] = useState({});

	const options = [
		{ key: "Detallado Conversación", text: "Detallado Conversación", value: "Detallado Conversación" },
		{ key: "Primera Respuesta", text: "Primera Respuesta", value: "Primera Respuesta" },
		{ key: "Resumido Usuarios", text: "Resumido Usuarios", value: "Resumido Usuarios" },
		{ key: "Resumido Grupos", text: "Resumido Grupos", value: "Resumido Grupos" },
		{ key: "Resumido Grupos/Usuarios", text: "Resumido Grupos/Usuarios", value: "Resumido Grupos/Usuarios" },
		// { key: "Por Dias", text: "Por Dias", value: "Por Dias" },
		// { key: "Hora/Usuarios", text: "Hora/Usuarios", value: "Hora/Usuarios" },
		// { key: "Hora/Grupos", text: "Hora/Grupos", value: "Hora/Grupos" },
	];

	const platforms = useMemo(() => {
		return uniqBy(
			map(channels, (item) => {
				return item.platform;
			}),
			"name"
		);
	}, [channels]);

	const defaultParams = { page: 1, orderKey: "lastLog.startDate", orderDir: "desc", rows: 15 };
	useEffect(() => {
		(async () => {
			const companyUsersPromese = await dataHandler({
				dispatch,
				url: "chats",
				params: defaultParams,
			});

			// const newCountValue = getStateQuantity(companyUsersPromese, "Nuevo");
			// const agentCountValue = getStateQuantity(companyUsersPromese, "Desconectado");
			// const clientCountValue = getStateQuantity(companyUsersPromese, "Cliente");
			// const allCountValue = newCount + agentCount + clientCount;
			// console.log(agentCountValue);
			setFilteredCount(companyUsersPromese.count);
			setFilteredItems(companyUsersPromese.items);
			setCheckAllData(get(chatCurrent, "chats", []));
			// setNewCount(newCountValue);
			// setAgentCount(agentCountValue);
			// setClientCount(clientCountValue);
			// setAllCount(allCountValue);
		})();
	}, []);

	// const handlerMultiple = (selectedItems) => {
	// 	setSelected(selectedItems);
	// };
	// Table handlers
	const handlerData = async (params, printable, findAll, isCheck = false) => {
		const data = await dataHandler({ dispatch, url: "chats", params });
		if (!isCheck && !printable) {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setTableValue(data.items);
		}
		if (printable) {
			setFilteredPrintData(data.items);
		}

		if (findAll) {
			setCheckAllData(data.items);
		} else {
			setCheckAllData([]);
		}
	};

	// const onSucces = () => {
	// 	if (onTagClose) {
	// 		onSuccesTags();
	// 		onClose();
	// 	}
	// };

	// save handlers
	// const handlerSaved = async () => {
	// 	const tagsId = map(selected, (tag) => {
	// 		return get(tag, "tagId", null);
	// 	});
	// 	await dispatch(tagChat(get(chatCurrent, "id", null), tagsId, onSucces));
	// 	onClose();
	// };
	// // Table Handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				setIsOpenModal(true);
				setTableValue(item);
				break;
			default:
				break;
		}
	};

	const handleFilterData = () => {
		setIsOpenModal(true);
	};
	// const handlerData = async (params) => {
	// 	const data = await dataHandler({ dispatch, url: "tags", params });
	// 	setFilteredItems(data.items);
	// 	setFilteredCount(data.count);
	// };

	const renderTopButtons = () => {
		return [
			{
				icon: "filter",
				className: styles.refreshButton,
				onClick: handleFilterData,
				content: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
				label: Object.keys(appliedFilters).length > 0 ? "Filtrando" : "Filtrar",
			},
		];
	};

	const handleApplyFilters = (filters) => {
		setShowTable(true);
		setAppliedFilters(filters);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle={`Reporte Tiempo${seletedFilteres ? ` - ${seletedFilteres}` : ""}`}>
			{!seletedFilteres && (
				<div className={styles.grid}>
					<IkTable
						data={filteredItems}
						handlerTable={handleButtom}
						totalRows={filteredCount}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						filteredPrintData={filteredPrintData}
						searcher={{
							searchable: false,
							searchDisabled: false,
							filterButton: false,
						}}
						topButtons={renderTopButtons()}
						checkAllData={checkAlllData}
					/>
				</div>
			)}
			{seletedFilteres === "Primera Respuesta" && showTable && (
				<FirstResponse
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Resumido Usuarios" && showTable && (
				<SummaryUserTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Resumido Grupos" && showTable && (
				<SummaryGroupsTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Resumido Grupos/Usuarios" && showTable && (
				<UsersGroupsTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{seletedFilteres === "Detallado Conversación" && showTable && (
				<DetailedTable
					dispatch={dispatch}
					companyName={companyName}
					userName={userName}
					onOpenFilterModal={handleFilterData}
					appliedFilters={appliedFilters}
				/>
			)}
			{isOpenModal && (
				<ActionUserCrud
					companyName={companyName}
					userName={userName}
					tableValue={tableValue}
					onClose={() => {
						setIsOpenModal(false);
					}}
					agents={agents}
					contacts={contacts}
					startDate={startDate}
					endDate={endDate}
					note={note}
					platformfilters={platformfilters}
					groupsfilters={groupsfilters}
					tagsSelected={tagsSelected}
					setAgents={setAgents}
					setContacts={setContacts}
					setStartDate={setStartDate}
					setEndDate={setEndDate}
					setNote={setNote}
					setPlatformfilters={setPlatformfilters}
					setGroupsfilters={setGroupsfilters}
					setTagsSelected={setTagsSelected}
					seletedFilteres={seletedFilteres}
					options={options}
					setSeletedFilteres={setSeletedFilteres}
					dateField={dateField}
					setDateField={setDateField}
					onApplyFilters={handleApplyFilters}
					platforms={platforms}
					channelFilters={channelFilters}
					setChannelFilters={setChannelFilters}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		channels: company.channels,
	};
}

TableActionUser.propTypes = {
	dispatch: PropTypes.func,
	chatCurrent: PropTypes.object,
	userName: PropTypes.string,
	companyName: PropTypes.string,
	channels: PropTypes.array,
};

export default connect(mapStateToProps)(TableActionUser);
